exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.fake {\n  color: \"red\";\n}\n#world-map-markers svg {\n  height: 355px;\n}\n.row.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.row.no-gutters > [class^=\"col-\"],\n.row.no-gutters > [class*=\" col-\"] {\n  padding-right: 0;\n  padding-left: 0;\n}\n.fa-star {\n  color: #605ca8;\n}\n.fa-star-o {\n  color: #605ca8;\n}\n.example-modal .modal {\n  position: fixed;\n  display: block;\n  z-index: 999999;\n}\n.example-modal .modal {\n  /*background: transparent !important;*/\n  background: #000000 0.3 !important;\n}\n.form-horizontal .form-group {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7dff9c0e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/Agent.vue
// module id = 385
// module chunks = 1